import { t } from "i18next"

export const getTranslations = t => {
  return {
    returnRequestOrder: (orderID, count, total) =>
      t("kf.returns.label.returnRequestOrder", { orderID, count, total }),
    returnDescription: t("kf.returns.label.returnDescription"),
    itemDescription: t("kf.returns.label.itemDescription"),
    returnNext: t("kf.returns.label.returnNext"),
    returnReviewSubmit: t("kf.returns.label.returnReviewSubmit"),
    returnTrack: t("kf.returns.label.returnTrack"),
    returnRequest: t("kf.returns.label.returnRequest"),
    returnProvideFeedback: t("kf.returns.label.returnProvideFeedback"),
    faultDescription: t("kf.returns.label.faultDescription"),
    faultLink: t("kf.returns.label.faultLink"),
    contactRequired: t("kf.returns.label.contactRequired"),
    reviewDescription: t("kf.returns.label.reviewDescription"),
    reviewPara: t("kf.returns.label.reviewPara"),
    reviewTerms: t("kf.returns.label.reviewTerms"),
    reviewParagraph: t("kf.returns.label.reviewParagraph"),
    reviewPrivacy: t("kf.returns.label.reviewPrivacy"),
    summaryTitle: t("kf.returns.label.summaryTitle"),
    "kf.returns.label.summaryTitle": "RETURN SUMMARY",
    summarySubTotal: t("kf.returns.label.summarySubTotal"),
    summaryTotal: t("kf.returns.label.summaryTotal"),
    summaryShipping: t("kf.returns.label.summaryShipping"),
    summaryFree: t("kf.returns.label.summaryFree"),
    returnRefund: t("kf.returns.label.returnRefund"),
    totalDiscount: t("kf.returns.label.totalDiscount"),
    refundTotal: t("kf.returns.label.refundTotal"),
    summaryRefundCost: t("kf.returns.label.summaryRefundCost"),
    summaryTax: t("kf.returns.label.summaryTax"),
    including: t("kf.returns.label.including"),
    taxes: t("kf.returns.label.taxes"),
    summaryChat: t("kf.returns.label.summaryChat"),
    summaryAgent: t("kf.returns.label.summaryAgent"),
    summaryCall: t("kf.returns.label.summaryCall"),
    summaryTel: t("kf.returns.label.summaryTel"),
    returnBack: t("kf.returns.label.returnBack"),
    requestTitle: t("kf.returns.label.requestTitle"),
    requestID: t("kf.returns.label.requestID"),
    requestTID: t("kf.returns.label.requestTID"),
    requestStatus: t("kf.returns.label.requestStatus"),
    requestTransit: t("kf.returns.label.requestTransit"),
    requestTracking: t("kf.returns.label.requestTracking"),
    requestTrackID: t("kf.returns.label.requestTrackID"),
    requestTrackLink: t("kf.returns.label.requestTrackLink"),
    requestFed: t("kf.returns.label.requestFed"),
    requestFaulty: t("kf.returns.label.requestFaulty"),
    requestProdDetails: t("kf.returns.label.requestProdDetails"),
    requestSerialNo: t("kf.returns.label.requestSerialNo"),
    requestDealerName: t("kf.returns.label.requestDealerName"),
    requestProdDate: t("kf.returns.label.requestProdDate"),
    requestContact: t("kf.returns.label.requestContact"),
    requestContactName: t("kf.returns.label.requestContactName"),
    returnConfirmTitle: t("kf.returns.label.returnConfirmTitle"),
    returnConfirmPara: t("kf.returns.label.returnConfirmPara"),
    returnConfirmDay: t("kf.returns.label.returnConfirmDay"),
    returnConfirmItem: t("kf.returns.label.returnConfirmItem"),
    returnHelp: t("kf.returns.label.returnHelp"),
    returnerItems: t("kf.returns.label.returnerItems"),
    returnedItems: t("kf.returns.label.returnedItems"),
    returnerQuantity: t("kf.returns.label.returnerQuantity"),
    colorFinish: t("kf.returns.label.colorFinish"),
    returnQuantityValue: t("kf.returns.label.returnQuantityValue"),
    returnReason: t("kf.returns.label.returnReason"),
    returnReasonVal: t("kf.returns.label.returnReasonVal"),
    reasonForReturn: t("kf.returns.label.reasonsForReturn"),
    reasonError: t("kf.returns.label.reasonReturnError"),
    commentBoxPlaceholder: t("kf.returns.label.commentBoxPlaceholder"),
    dragAndDrop: t("kf.returns.label.dragAndDrop"),
    orText: t("kf.returns.label.orText"),
    uploadFileButton: t("kf.returns.label.uploadFileButton"),
    backToOrder: t("kf.returns.label.backToOrder"),
    installationService: sku =>
      t("kf.returns.label.installationService", { sku }),
    returnItem: t("kf.returns.label.returnItem"),
    faulty: t("kf.returns.label.faulty"),
    contactInfo: t("kf.returns.label.contactInfo"),
    review: t("kf.returns.label.review"),
    areYou: t("kf.returns.label.areYou"),
    allProgress: t("kf.returns.label.allProgress"),
    yes: t("kf.returns.label.yes"),
    no: t("kf.returns.label.no"),
    related: t("kf.returns.label.returnRelated"),
    eligible: t("kf.returns.label.returnEligible"),
    following: t("kf.returns.label.returnFollowing"),
    service: t("kf.returns.label.returnService"),
    imageUpload: t("kf.returns.label.imageUpload"),
    refundAmount: t("kf.returns.label.refundAmount"),
    noReason: t("kf.returns.label.noReason"),
    uploadPhoto: t("kf.returns.label.uploadFileButton"),
    uploadCountLimit: t("kf.returns.label.uploadCountLimit"),
    uploadMBLimit: t("kf.contactus.error.maxFileSizeLimit"),
    orText: t("kf.returns.label.orText"),
    errorFileType: t("kf.returns.label.fileType"),
    description: t("kf.returns.image.description"),
    shippingTooltip: t("kf.cart.label.shippingTooltip"),
  }
}
